import React from 'react';
import Icon from './AppIcon';
import Button from './ui/Button';
import { useNavigate } from 'react-router-dom';
import { stripeService } from '../services/stripeService';

const PilotExpirationModal = ({ userProfile, onClose, onDismiss }) => {
  const navigate = useNavigate();
  const daysRemaining = stripeService?.getDaysUntilPilotExpiration(userProfile);
  const expirationDate = stripeService?.getPilotModeExpiration(userProfile);

  const handleUpgrade = () => {
    navigate('/account?tab=subscription');
    onClose();
  };

  const handleDismiss = () => {
    onDismiss();
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card border border-border rounded-lg max-w-md w-full p-6 shadow-xl">
        <div className="flex items-start gap-4 mb-4">
          <div className="w-12 h-12 rounded-lg bg-warning/20 flex items-center justify-center flex-shrink-0">
            <Icon name="AlertTriangle" size={24} className="text-warning" />
          </div>
          <div className="flex-1">
            <h2 className="text-xl font-semibold text-foreground mb-2">
              Your Pilot Plan is Expiring Soon
            </h2>
            <p className="text-sm text-muted-foreground">
              Your 60-day free trial will end in <span className="font-semibold text-foreground">{daysRemaining} {daysRemaining === 1 ? 'day' : 'days'}</span> on {stripeService?.formatDate(expirationDate)}.
            </p>
          </div>
        </div>

        <div className="bg-muted/50 rounded-lg p-4 mb-6">
          <h3 className="text-sm font-semibold text-foreground mb-2">What happens next?</h3>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li className="flex items-start gap-2">
              <Icon name="CheckCircle" size={16} className="text-success mt-0.5 flex-shrink-0" />
              <span>Upgrade now to keep unlimited properties and offers</span>
            </li>
            <li className="flex items-start gap-2">
              <Icon name="XCircle" size={16} className="text-error mt-0.5 flex-shrink-0" />
              <span>Without upgrading, you'll be moved to the Free Plan (1 property, 2 offers)</span>
            </li>
            <li className="flex items-start gap-2">
              <Icon name="Sparkles" size={16} className="text-primary mt-0.5 flex-shrink-0" />
              <span>Continue enjoying AI-powered offer analysis with Pro</span>
            </li>
          </ul>
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="default"
            size="lg"
            onClick={handleUpgrade}
            iconName="ArrowUpRight"
            iconPosition="right"
            className="flex-1"
          >
            Upgrade to Pro
          </Button>
          <Button
            variant="outline"
            size="lg"
            onClick={handleDismiss}
            className="flex-1"
          >
            Remind Me Later
          </Button>
        </div>

        <p className="text-xs text-muted-foreground text-center mt-4">
          This reminder will appear each time you log in until you upgrade or your trial expires.
        </p>
      </div>
    </div>
  );
};

export default PilotExpirationModal;